import script from "./DiscoveryDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoveryDescription.vue?vue&type=script&setup=true&lang=js"

import "./DiscoveryDescription.vue?vue&type=style&index=0&id=a789acba&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a789acba"]])

export default __exports__